import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import useRouterMatch from './useRouterMatch';
export const userCacheKey = 'workspace-user';
function useTenantUser(uid?: string) {
  const { urlTenantId: tenantId } = useRouterMatch();
  const { data, isFetching, error } = useQuery(
    [userCacheKey, uid, tenantId],
    () => {
      if (!uid) return Promise.resolve(undefined);

      return BackendService.instance.tenant.getUser(uid);
    },
    {
      enabled: Boolean(uid),
      staleTime: 1000 * 60 * 15,
    },
  );
  return {
    user: data,
    error,
    isLoading: isFetching,
  };
}

export default useTenantUser;
